import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatList(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1Zm1-9h1V4H2v1h1v3Zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1Zm5-6v2h14V5H7Zm0 14h14v-2H7v2Zm0-6h14v-2H7v2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
